import React, { FunctionComponent } from 'react'
import { Rate, Comment, Tooltip, Typography } from 'antd'

import ProfileAvatar from '../ProfileAvatar/ProfileAvatar'

import { IReview, IUser } from '../../../context/types'

import moment from 'moment'

const { Paragraph } = Typography

// WISE-483
const HIDE_DATES = true

interface ReviewProps {
	review: IReview
	user: IUser
}

const Review: FunctionComponent<ReviewProps> = (props) => {
	const { review, user } = props

	return (
		<Comment
			author={review.leftBy.first_name + ' ' + review.leftBy.last_name}
			avatar={<ProfileAvatar src={review.leftBy.profile_pic_url} />}
			content={
				<>
					<Paragraph>{review.body}</Paragraph>
					<Rate className="expert-rate" value={review.rating} disabled />
				</>
			}
			datetime={
				HIDE_DATES ? null : (
					<Tooltip title={moment().format('YYYY-MM-DD HH:mm:ss')}>
						<span>{moment(review.left_on).fromNow()}</span>
					</Tooltip>
				)
			}
		>
			{!!review.responce && (
				<Comment
					author={user.first_name + ' ' + user.last_name}
					avatar={<ProfileAvatar src={user.profile_pic_url} />}
					content={<Paragraph>{review.responce}</Paragraph>}
					datetime={
						HIDE_DATES ? null : (
							<Tooltip title={moment().format('YYYY-MM-DD HH:mm:ss')}>
								<span>{moment(review.responded_on).fromNow()}</span>
							</Tooltip>
						)
					}
				/>
			)}
		</Comment>
	)
}

export default Review
